export const defaultButtonText = 'Submit Alternate ID Proof';
export const defaultAlternateDocHeader = 'Alternate ID Proof';
